import React, { useEffect, useState } from "react";
import { Card, Box, Typography } from "@mui/material";
import FullscreenExitOutlinedIcon from "@mui/icons-material/FullscreenExitOutlined";
import FullscreenOutlinedIcon from "@mui/icons-material/FullscreenOutlined";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import MixedChart from "./Graphs/Mixed/MixedChart";
import Valuecard from "./Graphs/ValueCard/Valuecard";
/* import Leafletmap from "./Map/Leafletmap"; */
import { useContext } from "react";
import "../../cssfiles/homepage.css";
import SwitchGauge from "./Graphs/Gauges/SwitchGauge";
import TextDonut from "./Graphs/Donut/TextDonut";
import DonutChartnewjson from "./Graphs/Donut/DonutChartnewjson";
import AssetMaintenanceDonutChartnewjson from "./Graphs/Donut/AssetMaintenanceDonutChartnewjson";
import SwitchFunnel from "./Graphs/Funnel/SwitchFunnel";
import LineChart from "./Graphs/Line/LineChart";
import LineChartnewjson from "./Graphs/Line/LineChartnewjson";
import BarChart from "./Graphs/Bar/BarChart";
import Treemap from "./Graphs/Treemap/Treemap";
import Tablewidget from "./Graphs/Table/Tablewidget";
import SankeyChart from "./Graphs/Sankey/Sankey";
import Accordiontable from "./Graphs/Table/AccordionTable";
import BarSelect from "./Graphs/Bar/BarSelect";
import LinearProgressBar from "./Graphs/LinearProgessBar/LinearProgessBar";
import AqiGauge from "./Graphs/Gauges/AqiGuage";
import EmTable from "./Graphs/Table/EmTable";
import Cardwidget from "./Graphs/Card/Cardwidget";
import Cardwidgetnewjson from "./Graphs/Card/Cardwidgetnewjson";
import DataTable from "./Graphs/Table/DataTable";
import Cardtext from "./Graphs/Card/Cardtext";
import DropdownTable from "./Graphs/Table/DropdownTable";
import DonutCategorywise from "./Graphs/Donut/DonutCategorywise";
import MixedIndividual from "./Graphs/Mixed/MixedIndividual";
import MixedIndividualnewjson from "./Graphs/Mixed/MixedIndividualnewjson";
import SwitchTable from "./Graphs/Table/SwitchTable";
import { statusCode } from "../../Restclient/datacollection";
import { useSelector, useDispatch } from "react-redux";
import WaterCard from "./Graphs/Card/WaterCard";
import WaterValueCard from "./Graphs/Card/WaterValueCard";
import WaterMultiValueCard from "./Graphs/Card/WaterMultiValueCard";
import Valuedatacard from "./Graphs/Card/Valuedatacard";
import Linechartnew from "./Graphs/Line/Linechartnew";
import Statuscard from "./Graphs/Status/Statuscard";
import SchedulerWidget from "./Graphs/Scheduler/Scheduler";
import Schedulercard from "./Graphs/Scheduler/Schedulercard";
import Simplebarchart from "./Graphs/Bar/Simplebarchart";
import Simplegauge from "./Graphs/Gauges/Simplegauge";
import Valuedatacardhist from "./Graphs/Card/Valuedatacardhist";
import Linearprogressbarsimplie from "./Graphs/LinearProgessBar/Linearprogressbarsimplie";
import Linearprogressbarsimplienewjson from "./Graphs/LinearProgessBar/Linearprogressbarsimplienewjson";
import Simplelinechart from "./Graphs/Line/Simplelinechart";
import Tablewidgetrealtime from "./Graphs/Table/Tablewidgetrealtime";
import SwitchTablerealhist from "./Graphs/Table/SwitchTablerealhist";
import Tablewidgetrealtimehistoricalrealtime from "./Graphs/Table/Tablewidgetrealtimehistoricalrealtime";
import AssetMaintenanceTablewidget from "./Graphs/Table/AssetMaintenanceTablewidget";
import ValueDeviation from "./Graphs/Value-Deviation/ValueDeviation";
import Map from "./Graphs/Map/Map";
import BBT from "./Graphs/BBT/BBT";
import TableGateway from "./Graphs/Table/TableGateway";
import TableAllGateway from "./Graphs/Table/TableAllGateway";
import TableDevice from "./Graphs/Table/TableDevice";
import GatewayDonut from "./Graphs/Donut/GatewayDonut";
import DeviceDonut from "./Graphs/Donut/DeviceDonut";
import EsgData from "./Graphs/ESG/EsgForm";
import ParameterListTable from "./Graphs/Table/ParameterListTable";
import ValueCardStatus from "./Graphs/Card/ValueCardStatus";
import Solarjson from "./Graphs/Solar/Solar";
import BillingDashboard from "./Billing/Billing";
import CustomerUtilityDashboard from "./Billing/Customer";
import UtilityMeterDashboard from "./Billing/Meter";
import UtilityTariffDashboard from "./Billing/Tariff";
export default function Widgetcard(props) {

  const [height, setHeight] = useState("313px");
  const [width, setWidth] = useState("350px");
  const [widgetname, setWidgetname] = useState(<></>);
  const [datechange, setDatechange] = useState("");
  const sdate_edate_selected = useSelector(
    (state) => state.mainpagedata.selecteddates
  );

  const sendwidgetdetails = () => {
    if (typeof props.maxicallback === "function") {
      props.maxicallback(props.widget, true);
    }
  };
  const exitmax = () => {
    if (typeof props.maxicallback === "function") {
      props.maxicallback(props.widget, false);
    }
  };
  const datejson = {
    dateselectontype: "defined", 
    showicon: true,
    showdate: false,
    font: {
      size: 16,
      weight: 600,
      color: "#000000",
    },
    icon: {
      width: 24,
      height: 24,
      color: "#000000",
    },
  };
  const handledatetimepicker = (dateselected) => {
    setDatechange(dateselected);
  };

  // Normalize basic & extended styling so background/text colors & font reflect in runtime view
  const basic = props?.widget?.props?.basic || {};
  const extended = props?.widget?.props?.extended || {};
  const normalizedBasic = {
    backgroundColor: basic.backgroundColor || "var(--SecondaryBackground)",
    textColor: basic.font_data?.color || basic.textColor || 'var(--LK_BrandBlue_1)',
    fontSize: parseInt((basic.font_data?.fontsize || basic.fontSize || '16').toString().replace('px','')) || 16,
    fontType: basic.font_data?.fonttype || basic.fontType || 'Roboto',
    borderColor: basic.border?.color || basic.borderColor || '#D8DFE3',
    // Only apply radius if explicitly provided; otherwise 0 (square corners)
    // borderRadius: (() => {
    //   const source = basic.border?.borderradius ?? basic.borderRadius;
    //   if (source === undefined || source === null || source === '') return 0;
    //   const val = parseInt(source.toString().replace('px',''));
    //   return isNaN(val) ? 0 : val;
    // })()
  };
  const datapoints = Array.isArray(extended?.datapoints) ? extended.datapoints : [];
  const showDatapointListFallback = datapoints.length > 0 && ![
    'mix','progressbar_mix','table','table_dropdown','switch_gauge','text_donut','text_donut_time_duration',
    'switch_dropdown_funnel','line','bar','treemap','text_donut_category_wise','sankey','accordiontable',
    'mix_individual_dropdown','linearprogressbar','card','valuecard','table_switch','singlevalue','linechart',
    'status','scheduler','schedulercard','simplebarchart','simplegauge','valuehist','lineargauge','simplelinechart',
    'tablereal','tablerealhistorical','valuedeviation','azuremap','valuedata','tablegateway','tabledevice',
    'gatewaydonut','devicedonut','esgdata','lineargauge_newjson','minimum_maximum_card_newjson','text_donut_newjson',
    'mix_individual_dropdown_newjson','line_newjson','asset_maintenance_due_donut','upcoming_maintenance_table',
    'paralistTable','value_card_status','solar_sld','text_card'
  ].includes(props.widget.type);

  return (
    <div style={{width:"100%"}}>
      <Card
        elevation={0}
        sx={{
          backgroundColor: normalizedBasic.backgroundColor,
          // borderRadius: `${normalizedBasic.borderRadius}px`,
          // Always show a 1px border; radius applied only if provided above.
          // border: `1px solid ${normalizedBasic.borderColor}`,
          height: basic.height,
          width: basic.width,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {props.widget.type !== "water_card" &&
        props.widget.type !== "water_value_card" &&
        props.widget.type !== "water_multi_value_card" ? (
          <>
            <Box
              sx={{
                height: "34px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                sx={{
                  marginLeft: "15px",
                  marginTop: "8px",
                  color: normalizedBasic.textColor,
                  fontSize: `${normalizedBasic.fontSize}px`,
                  fontWeight: 700,
                  fontFamily: normalizedBasic.fontType,
                }}
              >
                {" "}
                {props.widget.widgetname}{" "}
              </Typography>
              <Typography style={{ flexGrow: 1 }}> </Typography>
              {/* <InfoOutlinedIcon //commented icons for future use in case of need
                sx={{
                  width: "18px",
                  height: "18px",
                  marginRight: "10px",
                  color: "#C2CBC8",
                  marginTop: "8px",
                }}
              /> */}
              {/*<DateRangeOutlinedIcon sx={{width: '24px', height: '24px', paddingRight: '5px' , color: theme === 'dark' ? '#B5BFBC' : '#000000'}} onClick={handledatetimepicker}/>*/}
              {/*<Datetimepicker settings={datejson} datecallback={handledatetimepicker}/>*/}
              {/* {props.maxwidgetflag ? (
                <FullscreenExitOutlinedIcon
                  sx={{
                    width: "24px",
                    height: "24px",
                    paddingRight: "5px",
                    color: "#3F70B9",
                    marginTop: "8px",
                  }}
                  // onClick={exitmax}
                />
              ) : (
                <ZoomOutMapIcon
                  sx={{
                    width: "16px",
                    height: "16px",
                    paddingRight: "10px",
                    color: "#C2CBC8",
                    marginTop: "8px",
                  }}
                  // onClick={sendwidgetdetails}
                />
              )} */}
            </Box>
            {statusCode != 204 && (
              //console.log("widget cardstatusCode -props.widget.type", props.widget.type),
              <Box sx={{ height: "100%", flex:1, display:'flex', flexDirection:'column', overflow:'hidden' }}>
                {props.widget.type === "mix" && (
                  <MixedChart widgetprop={props.widget} />
                )}
                {props.widget.type === "progressbar_mix" && (
                  <MixedChart widgetprop={props.widget} />
                )}
                {props.widget.type === "table" && (
                  <Tablewidget widgetprop={props.widget} />
                )}
                {props.widget.type === "table_dropdown" && (
                  <DropdownTable widgetprop={props.widget} />
                )}
                {props.widget.type === "switch_gauge" && (
                  <SwitchGauge widgetprop={props.widget} />
                )}
                {props.widget.type === "text_donut" && (
                  <TextDonut widgetprop={props.widget} />
                )}
                {props.widget.type === "text_donut_time_duration" && (
                  <TextDonut widgetprop={props.widget} />
                )}
                {props.widget.type === "switch_dropdown_funnel" && (
                  <SwitchFunnel widgetprop={props.widget} />
                )}
                {props.widget.type === "line" && (
                  <LineChart widgetprop={props.widget} />
                )}
                {props.widget.type === "bar" && (
                  <BarChart widgetprop={props.widget} />
                )}
                {props.widget.type === "treemap" && (
                  <Treemap widgetprop={props.widget} />
                )}
                {props.widget.type === "text_donut_category_wise" && (
                  <DonutCategorywise widgetprop={props.widget} />
                )}
                {props.widget.type === "sankey" && (
                  <SankeyChart widgetprop={props.widget} />
                )}
                {props.widget.type === "accordiontable" && (
                  <Accordiontable widgetprop={props.widget} />
                )}
                {props.widget.type === "mix_individual_dropdown" && (
                  <MixedIndividual widgetprop={props.widget} />
                )}
                {/* props.widget.type === 'bar_select' && <BarSelect widgetprop={props.widget}/> */}
                {props.widget.type === "linearprogressbar" && (
                  <LinearProgressBar widgetprop={props.widget} />
                )}
                {props.widget.type === "card" && (
                  <Cardwidget widgetprop={props.widget} />
                )}
                {props.widget.type === "valuecard" && (
                  <Valuecard widgetprop={props.widget} />
                )}
                {props.widget.type === "table_switch" && (
                  <SwitchTable widgetprop={props.widget} />
                )}
                {props.widget.type === "singlevalue" && (
                  <Valuedatacard widgetprop={props.widget} />
                )}
                {props.widget.type === "linechart" && (
                  <Linechartnew widgetprop={props.widget} />
                )}
                {props.widget.type === "status" && (
                  <Statuscard widgetprop={props.widget} />
                )}
                {props.widget.type === "scheduler" && (
                  <SchedulerWidget widgetprop={props.widget} />
                )}
                {props.widget.type === "schedulercard" && (
                  <Schedulercard widgetprop={props.widget} />
                )}
                {props.widget.type === "simplebarchart" && (
                  <BarChart widgetprop={props.widget} />
                )}
                {/*props.widget.type === 'simplebarchart' && <Simplebarchart widgetprop={props.widget}/>*/}
                {/*props.widget.type === 'simplegauge' && <Simplegauge widgetprop={props.widget}/>*/}
                {props.widget.type === "simplegauge" && (
                  <Simplegauge widgetprop={props.widget} />
                )}
                {props.widget.type === "valuehist" && (
                  <Valuedatacardhist widgetprop={props.widget} />
                )}
                {props.widget.type === "lineargauge" && (
                  <Linearprogressbarsimplie widgetprop={props.widget} />
                )}
                {props.widget.type === "simplelinechart" && (
                  <LineChart widgetprop={props.widget} />
                )}
                {props.widget.type === "tablereal" && (
                  <Tablewidgetrealtime widgetprop={props.widget} />
                )}
                {props.widget.type === "tablerealhistorical" && (
                  <SwitchTablerealhist widgetprop={props.widget} />
                )}
                {props.widget.type === "valuedeviation" && (
                  <ValueDeviation widgetprop={props.widget} />
                )}
                {props.widget.type === "azuremap" && (
                  <Map widgetprop={props.widget} />
                )}
                {props.widget.type === "valuedata" && (
                  <BBT widgetprop={props.widget} />
                )}
                {props.widget.type === "tablegateway" && (
                  <TableGateway widgetprop={props.widget} />
                )}
                {props.widget.type === "tableallgateway" && (
                  <TableAllGateway widgetprop={props.widget} />
                )}
                {props.widget.type === "tabledevice" && (
                  <TableDevice widgetprop={props.widget} />
                )}
                {props.widget.type === "gatewaydonut" && (
                  <GatewayDonut widgetprop={props.widget} />
                )}
                {props.widget.type === "devicedonut" && (
                  <DeviceDonut widgetprop={props.widget} />
                )}
                {props.widget.type === "esgdata" && (
                  <EsgData widgetprop={props.widget} />
                )}
                {props.widget.type === "lineargauge_newjson" && (props.widget.props.extended.datatype=="real") && (
                  <Linearprogressbarsimplie widgetprop={props.widget} />
                )}
                {props.widget.type === "lineargauge_newjson" && (props.widget.props.extended.datatype=="hist") && (
                  <Linearprogressbarsimplienewjson widgetprop={props.widget} />
                )}
                {props.widget.type === "minimum_maximum_card_newjson" && (props.widget.props.extended.datatype=="hist") && (
                  <Cardwidgetnewjson widgetprop={props.widget} />
                )}
                {props.widget.type === "text_donut_newjson" && (props.widget.props.extended.datatype=="hist") && (
                  <DonutChartnewjson widgetprop={props.widget} />
                )}
                {props.widget.type === "mix_individual_dropdown_newjson" && (
                  <MixedIndividualnewjson widgetprop={props.widget} />
                ) }
                {props.widget.type === "line_newjson" && (
                  <LineChartnewjson widgetprop={props.widget} />
                ) }
                {props.widget.type === "asset_maintenance_due_donut" && (
                  <AssetMaintenanceDonutChartnewjson widgetprop={props.widget} />
                ) }
                {props.widget.type === "upcoming_maintenance_table" && (
                  <AssetMaintenanceTablewidget widgetprop={props.widget} />
                ) }
                {props.widget.type === "paralistTable" && (
                  <ParameterListTable widgetprop={props.widget} />
                ) }
                {props.widget.type === "value_card_status" && (
                  <ValueCardStatus widgetprop={props.widget} />
                )}
                {props.widget.type === "solar_sld" && (
                  <Solarjson widgetprop={props.widget} />
                )}
                {props.widget.type === "CustomerUtilityDashboard" && (
                  <CustomerUtilityDashboard widgetprop={props.widget} />
                )}
                {props.widget.type === "UtilityMeterDashboard" && (
                  <UtilityMeterDashboard widgetprop={props.widget} />
                )}
                {props.widget.type === "UtilityTariffDashboard" && (
                  <UtilityTariffDashboard widgetprop={props.widget} />
                )}
                {props.widget.type === "BillingDashboard" && (
                  <BillingDashboard widgetprop={props.widget} />
                )}
                {/*props.widget.type === 'simplelinechart' && <Simplelinechart widgetprop={props.widget}/>*/}
                {/*props.widget.type === 'aqiguage' && <AqiGauge widgetprop={props.widget} />*/}
                {/*props.widget.type === 'emtable' && <EmTable widgetprop={props.widget} />*/}
                {/*props.widget.type === 'datatable' && <DataTable widgetprop={props.widget} />*/}
                {props.widget.type === 'text_card'? <Cardtext widgetprop={props.widget}/>:<></>}
                {showDatapointListFallback && (
                  <Box sx={{ p:1, display:'flex', flexDirection:'column', gap:0.75, overflowY:'auto' }}>
                    {datapoints.map(dp => (
                      <Box
                        key={dp.id || dp.key}
                        sx={{
                          display:'flex',
                          alignItems:'center',
                          justifyContent:'space-between',
                          border:'1px solid #E2E6E9',
                          // borderRadius:1.5,
                          px:1,
                          py:0.5,
                          backgroundColor: dp.backgroundColor || normalizedBasic.backgroundColor
                        }}
                      >
                        <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.75, minWidth:0 }}>
                          <Box sx={{ width:10, height:10, borderRadius:'50%', background: dp.textColor || normalizedBasic.textColor }} />
                          <Typography
                            sx={{ fontSize:12, fontFamily: normalizedBasic.fontType, fontWeight:400, color: dp.textColor || '#3A454E', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', maxWidth:'160px' }}
                            title={dp.datapointName || dp.name}
                          >
                            {dp.datapointName || dp.name }                        </Typography>
                        </Box>
                        <Typography sx={{ fontSize:11, fontFamily: normalizedBasic.fontType, color: dp.textColor || '#56636E' }}>
                          {dp.unit || ''}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            )}
          </>
        ) : (
          <Box sx={{ height: "100%" }}>
            {props.widget.type === "water_card" && (
              <WaterCard widgetprop={props.widget} />
            )}
            {props.widget.type === "water_value_card" && (
              <WaterValueCard widgetprop={props.widget} />
            )}
            {props.widget.type === "water_multi_value_card" && (
              <WaterMultiValueCard widgetprop={props.widget} />
            )}
          </Box>
        )}
      </Card>
    </div>
  );
}